import React, { Fragment, useMemo } from 'react';
import { useSubscribe } from '@core/utils/hooks/rxjs';
import { createHistory, HistoryProvider } from '@core/router';
import { ModalStack } from '@core/components/ModalStack';
import { Session } from '@modules/auth/session';
import { initBlocs, resetBlocs } from '@business/blocs';
import { AppRouter } from './AppRouter';
import { AppConfig } from '@core/utils/config';
import { Endpoint } from '@business/api/endpoint';
import { LoadingBar } from '@core/components/LoadingBar';
import ErrorBoundary from './ErrorBoundary';
import { PageContext } from '@core/components/PageContext';
import { PageFocusProvider } from '@core/components/PageFocusProvider';
import SimpleReactLightbox from 'simple-react-lightbox';
import { AppContextProvider } from '@core/components/AppContextProvider';
import 'spectrum-colorpicker2/src/spectrum.css';
import { AntDesignConfig } from './AntDesignConfig';
import { Theme } from '@core/utils/css';
import { useDidMount } from '@core/utils/hooks/react';

export default function App() {
  const history = useMemo(() => createHistory(), []);

  useSubscribe(Session.sessionStart$, url => {
    initBlocs();
    if (url) {
      history.replace(url);
    } else {
      history.replace('/');
    }
  });

  useSubscribe(Session.sessionEnd$, () => {
    history.replace('/login');
    resetBlocs();
  });

  AppConfig.get();

  useSubscribe(AppConfig.changed$, config => {
    Endpoint.setCompanyId(config.companyId);
  });

  const loadTheme = async () => {
    if (Theme.isDark) {
      // @ts-ignore
      await import('@styles/theme-dark.scss');
    } else {
      // @ts-ignore
      await import('@styles/theme.scss');
    }
  };

  useDidMount(() => {
    loadTheme();
  });

  return (
    <Fragment>
      {/* <Global styles={GlobalStyles} /> */}

      <HistoryProvider history={history}>
        <ErrorBoundary>
          <AppContextProvider>
            <PageFocusProvider>
              <LoadingBar>
                <PageContext>
                  <SimpleReactLightbox>
                    <AntDesignConfig>
                      <AppRouter />
                      <ModalStack />
                    </AntDesignConfig>
                  </SimpleReactLightbox>
                </PageContext>
              </LoadingBar>
            </PageFocusProvider>
          </AppContextProvider>
        </ErrorBoundary>
      </HistoryProvider>
    </Fragment>
  );
}
